<template>
<div class="to-premium-dialog">
  <div class="premium-wrapper">
    <div class="premium-wrapper-header">
        <div>
          {{title}}
          <p v-html="titleTips"></p>
        </div>
        <span @click="close">
          <svg-icon class="close" name="close3" ></svg-icon>
        </span>
    </div>
    <div class="premium-wrapper-main">
      <div class="premium-wrapper-left">
        <carousel-view @close="close"></carousel-view>
      </div>
      <div class="premium-wrapper-right">
        <common-template 
          :source="title == 'Assign More Loads ?' ? 'More Loads' : 'More Docs'"
           @close="close" title="Freemium"></common-template>
        <common-template :source="title == 'Assign More Loads ?' ? 'More Loads' : 'More Docs'" @close="close" title="COMMAND Premium"></common-template>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import commonTemplate from './freemium-premium-view/index.vue'
import carouselView from '../full-version-common-compontes/carousel-view/index.vue'
import appendToDom from "@/components-v3/mixins/append-to-dom"
export default {
  mixins: [appendToDom()],
  name: 'full-version-to-premium-dialog',
  components: { carouselView, commonTemplate },
  props: {
    title: {
      type: String,
      default: 'Assign More Loads ?'
    },
    titleTips: {
      type: String,
      default: 'Free subscriptions are limited to <span style=color:#000>10</span> loads. Upgrade subscription to get more.'
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.to-premium-dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}
.premium-wrapper {
  width: 900px;
  height: 540px;
  border-radius: 5px;
  background: #fff;
  &-header {
    width: 100%;
    display: flex;
    padding: 20px 24px;
    border-bottom: 1px solid #E7EBF3;
    justify-content: space-between;
    div {
      font-family: OpenSans;
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 26px;
      color: #000000;
    }
    p {
      margin-top: 4px;
      font-family: OpenSans;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #7F8596;
    }
  }
  &-main {
    display: flex;
  }
  &-left {
    width: 298px;
    height: 100%;
  }
  &-right {
    width: calc(100% - 298px);
    padding: 24px;
    display: flex;
    justify-content: space-between;
  }
}
.close {
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: #C4C4C4;
}
</style>